export default __webpack_public_path__ + "static/media/Great Sword of the Warded Brute.65c1e517.jpg";